import ActivosFijosScreen from "../../Screen/ERP/Global/ActivosFijos/ActivosFijosScreen";
import CandidatosScreen from "../../Screen/ERP/RRHH/Maestros/CandidatosScreen";
import MaestrosScreen from "../../Screen/ERP/RRHH/Maestros/MaestrosScreen";
import PersonalScreen from "../../Screen/ERP/RRHH/Personal/PersonalScreen";
import PosicionesScreen from "../../Screen/ERP/RRHH/Posiciones/PosicionesScreen";
import VacantesScreen from "../../Screen/ERP/RRHH/Vacantes/VacantesScreen";

export const RecursosHumanas = [
  {
    path: "RRHH/Posicion",
    permiso: 53,
    element: <PosicionesScreen />,
  },
  {
    path: "RRHH/Personal",
    permiso: 54,
    element: <PersonalScreen />,
  },
  {
    path: "RRHH/Maestros",
    permiso: 90,
    element: <MaestrosScreen />,
  },
  {
    path: "RRHH/Candidatos",
    permiso: 91,
    element: <CandidatosScreen />,
  },
  {
    path: "RRHH/Vacantes",
    permiso: 98,
    element: <VacantesScreen />,
  },

];
  
export default RecursosHumanas;
  